import styled from "styled-components";

import { BillboardFiltersStyledProps as Props } from "./BillboardFilters.types";
import CONSTANTS from "config/constants";

const { tablet } = CONSTANTS.BREAKPOINTS;

const BillboardFiltersStyled = styled.div<Props>`
  padding: 0 2.4rem;
  padding-bottom: 0.8rem;

  .BillboardFilters {
    &__title {
      display: flex;
      justify-content: center;
      color: var(--palette-white);
      font-size: 2.4rem;
      font-weight: 600;
    }

    &__subtitle {
      color: var(--palette-light-blue-s10-l60);
      font-size: 2rem;
      font-weight: 400;
      padding: 2.4rem 0;
    }

    &__filters {
      background-color: var(--palette-mid-blue-s15-l8);
      padding: 1.6rem;
      border: unset;
      box-shadow: none;
      border-radius: 0.8rem;
      min-width: 100%;
      justify-content: space-between;
      font-weight: 600;
      font-size: 1.4rem;

      &:hover:not([disabled]) {
        background-color: var(--palette-mid-blue-s15-l20);
        border: none;
        box-shadow: none;
      }

      &__selected {
        background-color: var(--palette-mid-blue-s15-l20);
        border: none;

        path {
          fill: var(--palette-primary);
        }
      }
    }

    &__name {
      color: var(--palette-white);

      &__container {
        text-align: start;
      }
    }

    &__line {
      height: 0.1rem;
      background-color: var(--palette-mid-blue-s15-l20);
      width: 96%;
    }

    &__selected {
      border: none;

      path {
        fill: var(--palette-primary);
      }
    }

    &__button {
      width: 100%;
      padding: 1.6rem;
      margin-top: 1.6rem;

      @media (max-width: ${tablet - 1}px) {
        margin-bottom: 1.6rem;
      }
    }
  }
`;

export const BillboardFiltersHeaderStyled = styled.div`
  flex: 1;
  padding: 1.6rem 0rem;
  display: flex;
  justify-content: center;
  align-items: center;

  .BillboardFilters {
    &__title {
      text-align: center;
      flex: 1;
      color: var(--palette-white);
      padding-top: 2.4rem;
      font-weight: 600;
      font-size: 2.8rem;
    }

    &__reset {
      margin-top: 3.2rem;
      margin-right: 1.6rem;
    }
  }
`;

export default BillboardFiltersStyled;
